var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEducation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 20,
    viewBox: "0 0 23 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.75 12.3568V9.237C16.75 9.0507 16.75 8.95755 16.7213 8.87531C16.6959 8.80258 16.6545 8.73635 16.6001 8.68139C16.5385 8.61924 16.4542 8.57758 16.2857 8.49426L11.5 6.12877M3.1 7.16677V14.2321C3.1 14.6181 3.1 14.8111 3.16092 14.9801C3.21477 15.1296 3.30255 15.2648 3.4175 15.3754C3.54753 15.5006 3.72504 15.581 4.08002 15.7419L10.8 18.7867C11.0575 18.9033 11.1863 18.9617 11.3204 18.9847C11.4392 19.0051 11.5608 19.0051 11.6796 18.9847C11.8137 18.9617 11.9425 18.9033 12.2 18.7867L18.92 15.7419C19.275 15.581 19.4525 15.5006 19.5825 15.3754C19.6975 15.2648 19.7852 15.1296 19.8391 14.9801C19.9 14.8111 19.9 14.6181 19.9 14.2321V7.16677M1 6.12877L11.1243 1.12442C11.2621 1.05634 11.331 1.0223 11.4032 1.0089C11.4672 0.997033 11.5328 0.997033 11.5968 1.0089C11.669 1.0223 11.7379 1.05634 11.8757 1.12442L22 6.12877L11.8757 11.1331C11.7379 11.2012 11.669 11.2352 11.5968 11.2486C11.5328 11.2605 11.4672 11.2605 11.4032 11.2486C11.331 11.2352 11.2621 11.2012 11.1243 11.1331L1 6.12877Z",
    stroke: "#565656",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEducation);
export default __webpack_public_path__ + "static/media/education.5f0162ba48149e9124210145711e49b2.svg";
export { ForwardRef as ReactComponent };